import moment from 'moment';
import { NOTIFICATION_STATUS_CODE } from '../../enums/notification-status-code.enum';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { NumberUtilities } from '../../utilities/number-utilities';
import { TimeUtilities } from '../../utilities/time-utilities';
import {
    JsonNotificationIdentifierModel,
    NotificationIdentifierModel,
    NotificationIdentifierModelFromJson,
} from './notification-identifier.model';

export class NotificationUpdateModel {
    public notificationUpdateKey: string;
    public constructor(
        public notificationId: NotificationIdentifierModel,
        public date: moment.Moment,
        public message: string,
        public messageType: NOTIFICATION_STATUS_CODE,
        public isActive: boolean,
    ) {
        this.notificationUpdateKey = `${date}-${NumberUtilities.getRandomNumberBetweenMinAndMax()}`;
    }

    public static fromOData(data: ODataNotificationUpdateModel): NotificationUpdateModel {
        return new NotificationUpdateModel(
            new NotificationIdentifierModel(data.FrontId, data.NotificationNo, data.TaskNumber),
            TimeUtilities.momentFromDateAndTime(data.Date, data.Time),
            data.MessageText,
            data.MessagetypeCSE,
            true,
        );
    }

    /**
     * Checks for notification cancellation updates
     *
     * @returns {boolean}
     */
    public isMessageTypeCancelled(): boolean {
        return this.messageType === NOTIFICATION_STATUS_CODE.AVR1 || this.messageType === NOTIFICATION_STATUS_CODE.AVR2;
    }

    /**
     * Compare only for notificationId and messageType since notificationUpdateKey may change for same NotificationUpdateModel
     *
     * @param {NotificationUpdateModel} firstUpdate
     * @param {NotificationUpdateModel} secondUpdate
     * @returns {boolean}
     */
    public static compare(firstUpdate: NotificationUpdateModel, secondUpdate: NotificationUpdateModel): boolean {
        return (
            firstUpdate.notificationId.equalsTo(secondUpdate.notificationId) &&
            firstUpdate.messageType === secondUpdate.messageType &&
            firstUpdate.message === secondUpdate.message
        );
    }
}

export class NotificationUpdateModelFromJson extends NotificationUpdateModel {
    public constructor(data: JsonNotificationUpdateModel) {
        super(
            new NotificationIdentifierModelFromJson(data.notificationId),
            moment(data.date),
            data.message,
            data.messageType,
            data.isActive,
        );
    }
}

export interface ODataNotificationUpdateModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: 'HC_SM_NGM_58_SRV.WhatsNew';
    };
    FrontId: string;
    NotificationNo: string;
    TaskNumber: string;
    Date: string;
    Time: string;
    MessageText: string;
    MessagetypeCSE: NOTIFICATION_STATUS_CODE;
}

export interface JsonNotificationUpdateModel {
    notificationId: JsonNotificationIdentifierModel;
    date: string;
    message: string;
    messageType: NOTIFICATION_STATUS_CODE;
    isActive: boolean;
}
